import React from 'react';
import { Box, Typography } from '@mui/material';
import { FeatureRequestStatus, STATUS_LABELS } from '../../types/featureRequests';

interface StatusStyle {
  bg: string;
  dot?: string;
  text: string;
}

const STATUS_STYLE: Record<FeatureRequestStatus, StatusStyle> = {
  under_review: { bg: 'rgba(0,0,0,0.05)', dot: '#8a8a94', text: '#5c5c66' },
  planned: { bg: 'rgba(33,150,243,0.10)', dot: '#2196f3', text: '#1565c0' },
  in_progress: { bg: 'rgba(255,152,0,0.12)', dot: '#ff9800', text: '#b26a00' },
  // Solid fill, not a soft tint — shipping is worth celebrating differently
  // from the other, still-pending statuses.
  shipped: { bg: '#4caf50', text: '#ffffff' },
  not_planned: { bg: 'rgba(244,67,54,0.08)', dot: '#f44336', text: '#c62828' },
  custom_dev: { bg: 'rgba(233,109,154,0.12)', dot: '#e96d9a', text: '#ad3f68' },
};

interface StatusPillProps {
  status: FeatureRequestStatus;
  size?: 'small' | 'medium';
}

const StatusPill: React.FC<StatusPillProps> = ({ status, size = 'small' }) => {
  const style = STATUS_STYLE[status];
  const compact = size === 'small';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: compact ? '5px 11px 5px 9px' : '6px 13px 6px 11px',
        borderRadius: '20px',
        backgroundColor: style.bg,
        lineHeight: 1,
      }}
    >
      {style.dot && (
        <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: style.dot, flexShrink: 0 }} />
      )}
      <Typography sx={{ fontSize: compact ? 11.5 : 12.5, fontWeight: 700, color: style.text, lineHeight: 1 }}>
        {STATUS_LABELS[status]}
      </Typography>
    </Box>
  );
};

export default StatusPill;
